import { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Alert, Button, Card, CardActionArea, CardContent, Stack, TextField, Typography } from '@mui/material';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import {
  createCurriculumMutation,
  listCurriculaOptions,
  listCurriculaQueryKey,
} from '@drivingdoc/api-client/generated/react-query';

import { PageContainer } from 'components/PageContainer';

export default function CurriculumListPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const curricula = useQuery(listCurriculaOptions());
  const create = useMutation(createCurriculumMutation());
  const [title, setTitle] = useState('');

  const createCurriculum = async () => {
    const curriculum = await create.mutateAsync({ body: { title } });
    await queryClient.invalidateQueries({ queryKey: listCurriculaQueryKey() });
    navigate(`/admin/learning/curricula/${curriculum.id}`);
  };

  return (
    <PageContainer title="Curricula">
      <Stack spacing={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
          <TextField
            label="New curriculum title"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            fullWidth
          />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            disabled={!title.trim() || create.isPending}
            onClick={createCurriculum}
          >
            Create
          </Button>
        </Stack>
        {create.isError && <Alert severity="error">Could not create the curriculum.</Alert>}
        {curricula.data?.map((curriculum) => (
          <Card key={curriculum.id} variant="outlined">
            <CardActionArea onClick={() => navigate(`/admin/learning/curricula/${curriculum.id}`)}>
              <CardContent>
                <Typography variant="h6">{curriculum.title}</Typography>
                <Typography color="text.secondary">
                  {curriculum.draft.modules.length} module(s) · revision {curriculum.revision}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
        {curricula.data?.length === 0 && <Typography color="text.secondary">No curricula yet.</Typography>}
      </Stack>
    </PageContainer>
  );
}
